import React from 'react';

import { colors } from 'src/styling/constants';

import type { IconProps } from './icon-types';

const TimeCircle = ({ size, fill = colors.capeCod }: IconProps) => (
  <div style={{ width: size || '100%', height: size || '100%' }}>
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 0.671875C14.584 0.671875 18.7031 4.79102 18.7031 9.875C18.7031 14.959 14.584 19.0781 9.5 19.0781C4.41602 19.0781 0.296875 14.959 0.296875 9.875C0.296875 4.79102 4.41602 0.671875 9.5 0.671875ZM9.5 17.2969C13.582 17.2969 16.9219 13.9941 16.9219 9.875C16.9219 5.79297 13.582 2.45312 9.5 2.45312C5.38086 2.45312 2.07812 5.79297 2.07812 9.875C2.07812 13.9941 5.38086 17.2969 9.5 17.2969ZM13.248 7.57422L10.9473 9.875L13.248 12.2129C13.4336 12.3613 13.4336 12.6582 13.248 12.8438L12.4316 13.6602C12.2461 13.8457 11.9492 13.8457 11.8008 13.6602L9.5 11.3594L7.16211 13.6602C7.01367 13.8457 6.7168 13.8457 6.53125 13.6602L5.71484 12.8438C5.5293 12.6582 5.5293 12.3613 5.71484 12.2129L8.01562 9.875L5.71484 7.57422C5.5293 7.42578 5.5293 7.12891 5.71484 6.94336L6.53125 6.12695C6.7168 5.94141 7.01367 5.94141 7.16211 6.12695L9.5 8.42773L11.8008 6.12695C11.9492 5.94141 12.2461 5.94141 12.4316 6.12695L13.248 6.94336C13.4336 7.12891 13.4336 7.42578 13.248 7.57422Z"
        fill={fill}
      />
    </svg>
  </div>
);

export default TimeCircle;
